function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 0A1.5 1.5 0 000 1.5v17A1.5 1.5 0 001.5 20h6.29a.102.102 0 00.092-.145A6.72 6.72 0 017.25 17.1c-.001-.055-.046-.1-.101-.1h-3.9a.75.75 0 01-.75-.75v-.5a.75.75 0 01.75-.75h4.228a.101.101 0 00.095-.07 6.738 6.738 0 011.25-2.26c.055-.067.008-.17-.078-.17H3.25a.75.75 0 01-.75-.75v-.5a.75.75 0 01.75-.75h8.91c.009 0 .018-.001.027-.004A6.757 6.757 0 0114 10.25c.649 0 1.276.091 1.87.262.065.019.13-.03.13-.096v-3.38a2.5 2.5 0 00-.732-1.768L10.732.732A2.5 2.5 0 008.964 0H1.5zm1.75 8a.75.75 0 01-.75-.75v-.5A.75.75 0 013.25 6h7a.75.75 0 01.75.75v.5a.75.75 0 01-.75.75h-7zM19 17a5 5 0 11-10 0 5 5 0 0110 0zm-3.192-1.692a.625.625 0 11.884.884l-3 3a.625.625 0 01-.884 0l-1.25-1.25a.625.625 0 11.884-.884l.808.808 2.558-2.558z",
  fill: "#B5BFCD"
});

var SvgDocCheck = function SvgDocCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    fill: "none"
  }, props), _ref);
};

export default SvgDocCheck;